<template>
    <div id="web-serp-root" class="web-serp-root">
        <div id="recipes-serp-wrapper" class="webSerpWrapper">
            <div id="web-serp-top" class="webSerpTop">
                <div id="search-wrapper" class="searchWrapper">
                    <auto-complete-input
                        v-model="query"
                        ref="queryInput"
                        id="query-input"
                        class="queryInput"
                        :group="-1"
                        :placeholder="branding.AutocompletePlaceholder"
                        @selected="onEnterSearch()"
                        @return="onEnterSearch()"
                        @iconClick="onEnterSearch()"
                        :dev="false"
                    />
                </div>
                <!--
                <div
                    id="filter-menu-btn"
                    class="filterMenuBtn"
                    @click="showFilterMenu = !showFilterMenu"
                >
                    <i class="fa fa-bars"></i>
                </div>
                -->
            </div>
            <!--
            <div
                id="recipes-serp-active-filters"
                class="recipesSerpActiveFilters"
            >
                <div
                    v-for="(filter, index) in resultCategory1"
                    :key="index"
                    :id="`active-filter_${index}`"
                    class="activeFilter"
                >
                    <div
                        class="activeFilterInnerWrapper"
                        @click="removeFilter(filter)"
                    >
                        <div class="activeFilterText">{{ filter }}</div>
                        <div class="activeFilterRemove">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
            -->
            <div id="web-serp-results" class="webSerpResults">
                <div
                    v-if="searchCompleted && topAds"
                    id="special-results-wrapper-top"
                    class="specialResultsWrapper"
                >
                    <div
                        id="special-top-results-inner-wrapper"
                        class="specialResultsInnerWrapper"
                    >
                        <div
                            v-for="(record, index) in topAds"
                            :key="index"
                            :id="`special-top-record_${index}`"
                            class="specialRecord record"
                        >
                            <a
                                :id="
                                    `special-top-results-primary-area_${index}`
                                "
                                class="specialResultsPrimaryArea"
                                target="_blank"
                                :href="record.url"
                                @click="sendXMLTracking(2)"
                            >
                                <div
                                    :id="`special-top-record-url_${index}`"
                                    class="specialRecordUrl recordUrl"
                                >
                                    {{ record.display_url }}
                                </div>
                                <div
                                    :id="`special-top-record-title_${index}`"
                                    class="specialRecordTitle recordTitle"
                                >
                                    <span class="specialRecordIdentifier"
                                        >Ad</span
                                    >
                                    <span v-html="record.title"></span>
                                </div>

                                <div
                                    :id="
                                        `special-top-record-description_${index}`
                                    "
                                    class="specialRecordDescription recordDescription"
                                >
                                    <span v-html="record.description"></span>
                                </div>
                            </a>
                            <div
                                v-if="
                                    record.site_links &&
                                        record.site_links.length > 0
                                "
                                :id="
                                    `special-top-record-site-links-wrapper_${index}`
                                "
                                class="specialRecordSiteLinksWrapper"
                            >
                                <div
                                    v-for="(link, index2) in record.site_links"
                                    :key="index2"
                                    :id="
                                        `special-top-record-site-link_${index}-${index2}`
                                    "
                                    class="specialRecordSiteLink"
                                >
                                    <a
                                        :id="
                                            `special-top-record-site-link-tag_${index}-${index2}`
                                        "
                                        class="specialRecordSiteLinkTag"
                                        target="_blank"
                                        :href="link.url"
                                        @click="sendXMLTracking(2)"
                                    >
                                        <span v-html="link.text" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="searchCompleted && organicRecords"
                    id="organic-results-wrapper"
                    class="organicResultsWrapper"
                >
                    <div
                        id="organic-results-inner-wrapper"
                        class="organicResultsInnerWrapper"
                    >
                        <div
                            v-for="(record, index) in organicRecords"
                            :key="index"
                            :id="`organic-record_${index}`"
                            class="organicRecord record"
                        >
                            <a
                                :id="`organic-results-link_${index}`"
                                class="organicResultsLink"
                                target="_blank"
                                :href="record.url"
                                @click="sendXMLTracking(3)"
                            >
                                <div
                                    :id="`organic-record-title_${index}`"
                                    class="organicRecordTitle recordTitle"
                                >
                                    <span v-html="record.title"></span>
                                </div>
                                <div
                                    :id="`organic-record-url_${index}`"
                                    class="organicRecordUrl recordUrl"
                                >
                                    {{ record.display_url }}
                                </div>
                                <div
                                    :id="`organic-record-description_${index}`"
                                    class="organicRecordDescription recordDescription"
                                >
                                    <span v-html="record.description"></span>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    v-if="searchCompleted && bottomAds"
                    id="special-results-wrapper-bottom"
                    class="specialResultsWrapper"
                >
                    <div
                        id="special-bottom-results-inner-wrapper"
                        class="specialResultsInnerWrapper"
                    >
                        <div
                            v-for="(record, index) in bottomAds"
                            :key="index"
                            :id="`special-bottom-record_${index}`"
                            class="specialRecord record"
                        >
                            <a
                                :id="
                                    `special-bottom-results-primary-area_${index}`
                                "
                                class="specialResultsPrimaryArea"
                                target="_blank"
                                :href="record.url"
                                @click="sendXMLTracking(3)"
                            >
                                <div
                                    :id="`special-bottom-record-title_${index}`"
                                    class="specialRecordTitle recordTitle"
                                >
                                    <span class="specialRecordIdentifier"
                                        >Ad</span
                                    >
                                    <span v-html="record.title"></span>
                                </div>
                                <div
                                    :id="`special-bottom-record-url_${index}`"
                                    class="specialRecordUrl recordUrl"
                                >
                                    {{ record.display_url }}
                                </div>
                                <div
                                    :id="
                                        `special-bottom-record-description_${index}`
                                    "
                                    class="specialRecordDescription recordDescription"
                                >
                                    <span v-html="record.description"></span>
                                </div>
                            </a>
                            <div
                                v-if="
                                    record.site_links &&
                                        record.site_links.length > 0
                                "
                                :id="
                                    `special-bottom-record-site-links-wrapper_${index}`
                                "
                                class="specialRecordSiteLinksWrapper"
                            >
                                <div
                                    v-for="(link, index2) in record.site_links"
                                    :key="index2"
                                    :id="
                                        `special-bottom-record-site-link_${index}-${index2}`
                                    "
                                    class="specialRecordSiteLink"
                                >
                                    <a
                                        :id="
                                            `special-bottom-record-site-link-tag_${index}-${index2}`
                                        "
                                        class="specialRecordSiteLinkTag"
                                        target="_blank"
                                        :href="link.url"
                                        @click="sendXMLTracking(2)"
                                    >
                                        <span v-html="link.text"
                                    /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="web-pagination-wrapper" class="webPaginagtionWrapper">
                    <div
                        v-if="prevLink"
                        id="web-prev-button"
                        class="paginationButton"
                        @click="paginate(prevLink)"
                    >
                        Previous
                    </div>
                    <div
                        v-if="nextLink"
                        id="web-next-button"
                        class="paginationButton"
                        @click="paginate(nextLink)"
                    >
                        Next
                    </div>
                </div>
                <div
                    v-if="
                        searchCompleted &&
                            !topAds &&
                            !bottomAds &&
                            !organicRecords
                    "
                    class="noResults"
                >
                    <div class="mobile-web-noresults">
                        Your search for "<span class="noresults-keyword">{{
                            enteredQuery
                        }}</span
                        >" did not match any recipe.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import queryString from "query-string";
import { documentReady, getTypeTag } from "@/common";
import { CURRENT_HOST, YAHOO_SEARCH_API_URL } from "@/urls";
import { clickEvent, yahooXMLClickEvent } from "@/analytics";
import { validatePop, verticals } from "@/pages/search/views/mixins/verticals";

import helper, {
    RECIPES_FILTER_IMAGE_URLS,
} from "@/pages/search/views/recipes/Helper";
import AutoCompleteInput from "@/components/autoCompleteInput/MobileAutoCompleteInput.vue";
import { getBranding } from "@/branding";

export default {
    mixins: [verticals],
    name: "serp",
    components: {
        "auto-complete-input": AutoCompleteInput,
    },
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            query: qs.q || "",
            typeTag: qs.type || null,
            showFilterMenu: false,
            openFilterMenus: [],
            currentSelectedFilters: [],
            searchCompleted: false,
            trigger: 150,
            perPageNo: 10,
            maxPageNum: 10,
            helper,
            badSearch: false,
            currentPage: 0,
            searchCompleted: false,
            totalPages: null,
            totalRecords: null,
            fullSearchResponse: null,
            branding: getBranding(),
        };
    },
    mounted() {
        documentReady.then(async () => {
            await this.handleSearchUrl();
            this.firstRunQuery = this.query;
            this.firstRunCount = this.totalRecords;
            this.firstLoad = false;
        });
    },
    watch: {},
    methods: {
        sendXMLTracking(type) {
            yahooXMLClickEvent(type, this.fullSearchResponse);
        },
        blurInputFocus() {
            this.$refs.queryInput.blur();
        },
        getAdsTitleText() {
            return `Ads Related to ${this.enteredQuery}`;
        },
        paginate(link) {
            this.doSearch(link);
            this.goToTop();
        },
        goToUrl(url, openNewTab = false) {
            if (!openNewTab) {
                return window.open(
                    url,
                    window.self !== window.top ? "_parent" : "_self"
                );
            }
            window.open(url, "_blank");
        },
        onEnterSearch() {
            if (
                (this.query &&
                    this.enteredQuery &&
                    this.query != this.enteredQuery) ||
                (this.query && !this.enteredQuery)
            ) {
                const url = new URL(window.location.href);
                if (this.query) url.searchParams.set("q", this.query);
                else url.searchParams.delete("q");
                const title = `Freshy Web Search - ${this.query}`;
                document.title = title;
                window.history.pushState(
                    { path: url.toString() },
                    `Freshy Web Search - ${this.query}`,
                    url.toString()
                );
            }

            this.freshQuerySearch();
        },
        async freshQuerySearch(fromUrl = false) {
            // close first run
            if (!fromUrl) this.whichPop = false;

            this.badSearch = false;
            this.enteredQuery = this.query;

            await this.doSearch(fromUrl);
        },
        async doSearch(paginationLink = false) {
            const term = this.enteredQuery;

            if (term) {
                this.fullSearchResponse = null;
                this.badSearch = false;

                // this.currentPage = 0;

                this.searchCompleted = false;

                let url = `${YAHOO_SEARCH_API_URL}?serve_url=${CURRENT_HOST}${
                    window.location.pathname
                }&q=${encodeURIComponent(term)}&ads=10&bold=1&type=${this
                    .typeTag || getTypeTag("Y219_F1_201405_")}`;

                if (paginationLink) url += `&${paginationLink}`;

                const req = await fetch(url, {});
                if (req.ok) {
                    const res = await req.json();

                    this.fullSearchResponse = res;
                    this.searchCompleted = true;
                } else {
                    this.badSearch = true;
                    this.searchCompleted = true;
                }
            }
        },
    },
    computed: {
        topAds() {
            if (this.newAdRecords) {
                if (this.newAdRecords.length >= 3) {
                    return this.newAdRecords.slice(0, 3);
                }
                return null;
            }
            return null;
        },
        bottomAds() {
            if (this.newAdRecords) {
                if (this.newAdRecords.length >= 6) {
                    return this.newAdRecords.slice(3, 6);
                }
                return null;
            }
            return null;
        },
        newAdRecords() {
            if (this.fullSearchResponse) return this.fullSearchResponse.ads;
            return null;
        },
        organicRecords() {
            if (this.fullSearchResponse) return this.fullSearchResponse.organic;
            return null;
        },
        prevLink() {
            if (this.fullSearchResponse)
                return this.fullSearchResponse.prevlink;
            return null;
        },
        nextLink() {
            if (this.fullSearchResponse)
                return this.fullSearchResponse.nextlink;
            return null;
        },
    },
};
</script>
<style>
@import "../common/common.css";
@import "./web.css";
</style>
